var exports = {
  "D": "x43aef4ae--2bf7b5--title",
  "v": "x43aef4ae--2bf7b5--tabs",
};

module.exports = exports;
